/**
 * Temporary local mirror of `ApplicantPortalOption` from `@dfg/entity-library`.
 *
 * brahma is pinned to entity-library `1.0.166`, which predates this enum. The
 * version that introduced it, `1.0.192`, depends on `@dfg/be-stdlib`, which pulls
 * in OpenTelemetry and gRPC (`@opentelemetry/sdk-node`, `@grpc/grpc-js`,
 * `protobufjs`, `node:crypto`). `src/middleware.ts` reaches entity-library through
 * `@brahma/utils` → `@dfg/brahma-types`, so that stack lands in the Edge Runtime
 * bundle, where dynamic code evaluation and `node:` schemes are forbidden and the
 * build fails to compile. Bumping the pin is therefore not an option today.
 *
 * The string values are a cross-repo contract: garuda reads this same enum from
 * entity-library `1.0.192`, so any divergence here silently breaks option
 * visibility rather than failing loudly. Keep the member set and the values
 * byte-for-byte identical to
 * `@dfg/entity-library/lib/pure-types/services/jaya-vijaya/PlatformPreferences`.
 *
 * This file intentionally has no imports so that client components can reach the
 * enum without dragging in the route-rules module or `$locale/constants`.
 *
 * Removed once the deferred brahma-types type-sharing follow-up lands and brahma
 * can consume the enum without the be-stdlib runtime.
 *
 * An applicant-portal option a co-branded deployment can hide.
 * Named after what the applicant sees, not after a route: one option covers every
 * side panel entry, CTA and route that makes it up. Members are added only for
 * entry points reachable without an existing verification request, with one
 * exception: `SELF_INITIATED_ACTION_CARDS` restricts the home "Important
 * Updates" action cards.
 */
export enum ApplicantPortalOption {
  START_NEW_VERIFICATION = 'START_NEW_VERIFICATION',
  HOME_PACKAGE_SELECTION = 'HOME_PACKAGE_SELECTION',
  CHECK_VERIFICATION_STATUS = 'CHECK_VERIFICATION_STATUS',
  ANCILLARY_SERVICES = 'ANCILLARY_SERVICES',
  TRUEPROFILE_WALLET = 'TRUEPROFILE_WALLET',
  SETTINGS = 'SETTINGS',
  MANAGE_PROFILE = 'MANAGE_PROFILE',
  VIEW_TRANSACTIONS = 'VIEW_TRANSACTIONS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SUPPORT = 'SUPPORT',
  SUPPORT_CHATBOT = 'SUPPORT_CHATBOT',
  SELF_INITIATED_ACTION_CARDS = 'SELF_INITIATED_ACTION_CARDS'
}
